const ignoreColumns = ["rec", "inf", "name"];


export const parseHTMLFile = (fileText) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(fileText, "text/html");
  const table = doc.querySelector("table");
  const rows = table.querySelectorAll("tr");

  const headerRow = table.querySelector("tr");
  const headers = Array.from(headerRow.querySelectorAll("th")).map(th => th.innerHTML);
  const bodyRows = Array.from(rows).slice(1);
  
  const rowData = bodyRows.map(bodyRow => mapBodyRow(bodyRow, headers));
  return rowData.filter(row => row.club !== "");
}


const mapBodyRow = (bodyRow, headers) => {
  const cells = Array.from(bodyRow.querySelectorAll("td"));
  
  return cells.reduce((acc, cell, i) => {
    if (ignoreColumns.includes(headers[i].toLowerCase())) return acc;
    if (headers[i].toLowerCase() === "club") return {...acc, club: cell.innerHTML};
    if (headers[i].toLowerCase() === "wage") return {...acc, wage: parseWageFromCell(cell.innerHTML)};
    if (headers[i].toLowerCase() === "position") {
      return {...acc, ...parsePositionFromCell(cell.innerHTML)};
    }
    
    acc[headers[i].toLowerCase()] = parseValueFromCell(cell.innerHTML);
    return acc;
  }, {});
}


const parsePositionFromCell = (cellContent) => {
  const striker = new RegExp("ST|AM").test(cellContent);
  const midfielder = new RegExp("(?<!A)M").test(cellContent);
  const defender = new RegExp("(D(?!M)|WB)").test(cellContent);
  const goalkeeper = cellContent.includes("GK");

  return {
    striker,
    midfielder,
    defender,
    goalkeeper,
  };
}


const parseValueFromCell = (cellContent) => {
  if (cellContent === "-") return undefined;
  if (cellContent.includes("-")) {
    const [min, max] = cellContent.split("-").map(value => parseInt(value));
    return min + (max - min) / 2;
  }
  return parseInt(cellContent)
}


const parseWageFromCell = (cellContent) => {
  const numericalCharacters = cellContent.match(/\d/g);
  if (!numericalCharacters) return 0;
  return parseInt(numericalCharacters.join(''));
}
